import { Badge } from '@abyss/web/ui/Badge';
import { Flex } from '@abyss/web/ui/Flex';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { useTranslation } from 'react-i18next';

import { usePrimaryCare } from '../../hooks/usePrimaryCare';
import { getShowEditPCP } from '../../utils/primaryCare.utils';
import { getLoggedInMember } from '../../utils/user.utils';
import { CareTeamDropDown } from './CareTeamProviderCard.styled';

export const ProviderCardHeader = ({
  isPcP,
  menuItems,
  isExternalPlanMember,
}: {
  isPcP: boolean;
  menuItems: {
    title: string;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  }[];
  isExternalPlanMember: boolean;
}) => {
  const { t } = useTranslation();
  const { data } = usePrimaryCare();
  const { primaryCare } = data;
  const loggedInMemberInfo = getLoggedInMember();
  const lockInIndicator = primaryCare?.[0]?.lockInIndicator;
  const showEditPCP = getShowEditPCP(
    loggedInMemberInfo.editPcp,
    lockInIndicator
  );
  return (
    <Flex
      alignItems="center"
      justify="space-between"
      style={{
        width: '100%',
      }}
    >
      {isPcP && (
        <Badge
          css={{ margin: '$sm' }}
          data-testid="pcp-badge"
          outline
          variant="success"
        >
          {t('PCP')}
        </Badge>
      )}
      {!(isExternalPlanMember && isPcP) && (
        <Flex
          data-testid="care-team-dropdown-wrapper"
          justify="flex-end"
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
          }}
          style={{
            flex: 1,
          }}
        >
          {(showEditPCP || !isPcP) && (
            <CareTeamDropDown
              after={<IconSymbol icon="keyboard_arrow_down" />}
              data-testid="care-team-dropdown"
              label={
                isPcP
                  ? t('PRIMARY_CARE_PROVIDER.EDIT_PCP')
                  : t('PRIMARY_CARE_PROVIDER.EDIT')
              }
              menuItems={menuItems}
              outline={false}
            />
          )}
        </Flex>
      )}
    </Flex>
  );
};
